export const CATEGORY_COLUMN_SIZE = {
    minSize: 250,
    maxSize: 350,
};

export const DOCUMENT_CATEGORY_COLUMN_SIZE = {
    minSize: 300,
    maxSize: 380,
};

export const AMOUNT_COLUMN_SIZE = {
    minSize: 120,
    maxSize: 200,
};

export const DATE_COLUMN_SIZE = {
    minSize: 120,
    maxSize: 120,
};

// At the minimum the card still shows a few name characters, a truncated
// "Via N line items" chip, the amount, and the row menu beside it.
export const SCHEDULE_COLUMN_SIZE = {
    minSize: 260,
    maxSize: 480,
};
